module.exports = __webpack_public_path__ + "img/wx-share-coupon@2x.717bc5ca.png";